<script>
// import Layout from "../../layouts/main.vue";
// import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from "axios";
import moment from 'moment';
// import Swal from "sweetalert2";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";

export default {
    page: {
        title: "View Monthly Statement",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role:localStorage.getItem('role'),
            title: "View Monthly Statement",
            items: [
                {
                text: "View Monthly Statement",
                href: "/",
                },
            ],

            rangeDateconfig: {
                mode: "range",
                dateFormat: "Y-m-d",
            },
        
            invoice_details:[],
            loadingDetail:false,
            loadingRoles:true,
            ButtonSeen:true,
            date: '',
            key_search:'',
            program_id:null,
            programList:null,
            dtKey:0,

            name_as_per_nric:'',
            phone_number:'',
            address:'',
            postalcode:'',
            city:'',
            state_name:'',
            invoice_description:'',
            invoice_amount:'',
            invoice_number:'',
            invoice_issue_date:'',
            invoice_due_date:'',
            
            loading: true,
            customer: null,
            transactions: [],
        };
    },

    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
            }
        },

        getInvoiceDetails(){
            this.loading = true;
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(`${process.env.VUE_APP_AR_API_BASEURL}soa/invoices/${this.$route.params.id}/preview`)
            .then(response => {
                console.log(response);
                if (response) {
                    this.customer = response.data.customer;
                    console.log(this.customer);
                    this.transactions = response.data.transactions;

                    this.loadingRoles=false;
                    this.invoice_details = response.data;
                    this.name_as_per_nric = this.invoice_details[0].name_as_per_nric;
                    this.phone_number = this.invoice_details[0].phone_number;
                    this.address = this.invoice_details[0].address;
                    this.postalcode = this.invoice_details[0].postalcode;
                    this.city = this.invoice_details[0].city;
                    this.state_name = this.invoice_details[0].state_name;
                    this.invoice_description = this.invoice_details[0].description;
                    this.invoice_amount = this.invoice_details[0].total_amount;
                    this.invoice_number = this.invoice_details[0].invoice_no;
                    this.invoice_issue_date = this.invoice_details[0].issue_date;
                    this.invoice_due_date = this.invoice_details[0].due_date;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            })
            .finally(()=> {
                this.loading = false;
            });
        },
    },

    // components: {
    //     Layout,
    //     PageHeader,
    // },

    mounted() {
        this.getInvoiceDetails();
    },
    
};
require("@/assets/css/datatable.css");
</script>
<style>
.card-header {
    padding: 3rem 5rem;
}
.col-width {
    width: 70%; 
}
</style>
<template>
    <div v-if="loading">
        ...
    </div>
    <div v-if="!loading" class="card" id="demo">
        <div class="p-4">
            <div class="d-sm-flex">
                <div class="flex-grow-1">                            
                    <div>
                        <img src="@/assets/images/compasiaLogo.png" class="card-logo card-logo-dark" alt="logo dark" height="52">
                    </div>
                    <div class="flex-shrink-0 mt-sm-0 mt-3 px-5">
                        <br><br><br><br>
                        <h6>
                            <p class="text-muted fw-normal" id="legal-register-no">{{ customer.customer_name }}</p>
                            <br>
                            <p class="text-muted fw-normal" id="legal-register-no">
                                {{ customer.customer_address }}, 
                                {{ customer.customer_postalcode }}, {{ customer.customer_city }}
                            </p>
                            <br>
                        </h6>
                        <h5><span class="fw-normal"><b></b></span><br></h5>
                        <p class="text-muted fw-normal" id="legal-register-no"></p>
                    </div>
                </div>
                <div class="flex-shrink-0 mt-sm-0 mt-3" style="max-width:40%">
                    <p><strong><h3>Statement Of Account</h3></strong></p>
                    <div class="d-flex flex-row-reverse">
                        <b>{{ customer.initial_date }} to {{ customer.final_date }}</b>
                    </div>        
                    <div class="d-flex flex-row-reverse">
                        <p class="text-danger font-italic">*Statement of Account as of {{ customer.final_date }}</p><br>
                    </div>
                    <div class="text-muted fw-normal" id="legal-register-no">
                        <br>
                        <label class="px-5 py-3 bg-light text-dark">Account Summary</label><br>
                        <table class="table borderless">
                            <thead>
                                <tr class="borderless" style="border-color: white;">
                                    <th scope="col">Amount(RM)</th> 
                                    <th scope="col" style="text-align: right;">{{ customer.invoice_amount }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="borderless" style="border-color: white;">
                                    <th scope="row">Paid(RM)</th>
                                    <td style="text-align: right;">{{ customer.paid_amount }}</td>
                                </tr>
                                <tr class="borderless" style="border-color: white;">
                                    <th scope="row">Due(RM)</th>
                                    <td style="text-align: right;">{{ customer.balance_amount }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <!-- <div class="float-right text-dark"><label class="text-dark"></label> </div><br> -->
                        <!-- <label class="text-dark"></label> <label class="px-5 float-right text-dark"></label><br> -->
                        <!-- <label class="text-dark"></label> <label class="px-5 float-right text-dark"></label> <br>  -->
                    </div>                                         
                </div>
            </div>
        </div>                   
        <div class="px-4 pt-5 border-top-dashed" style="border-top: 1px solid rgb(207, 211, 215);">                        
            <table class="table table-borderless" border="1">
                <thead>
                    <tr class="table-active">
                        <th class="text-start">Date</th>
                        <th class="text-start">Transaction</th>
                        <th class="text-start">Description</th>
                        <th class="text-end" style="text-align:right;">Debit</th>
                        <th class="text-end" style="text-align:right;">Credit</th>
                        <th class="text-end" style="text-align:right;">Balance</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in transactions" :key="index">                        
                        <td>{{ item.date }}</td>
                        <td>{{item.transaction}}</td>                               
                        <td>{{item.description}}</td>
                        <td style="text-align: right;">{{item.is_debit == true ? item.amount : ''}}</td>
                        <td style="text-align: right;">{{item.is_debit == false ? item.amount : ''}}</td>
                        <td style="text-align: right;">{{item.balance}}</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td class="text-end" style="text-align:right;"><strong>Balance:</strong> </td>
                        <td style="text-align: right;"><strong>{{ customer.balance_amount }}</strong></td>
                    </tr>
                </tbody>
            </table>
                   
                    <!-- <div class="row">
                        <div class="col-xl-6">
                            
                        </div>
                        <div class="col-xl-5">
                                <br><br>
                                <h5><b>Total Balance: &nbsp;<br></b></h5>
                                <br>
                                <br>
                                <center><small></small></center>
                        </div>
                    </div> -->
            <div class="mt-3">
                <h6 class="text-bold text-uppercase fw-semibold mb-3"></h6>
                <p class="text-muted mb-1"></p>
                <div clas="row">
                    <div class="col d-flex align-items-center justify-content-end">
                        <p class="lead"> <b></b></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>